import { FC } from 'react'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { Link } from 'react-router-dom'

const Error500: FC = () => {
  return (
    <>
      <div className="vertical_center">
        <div className='d-flex flex-column align-items-center item-container'>
          <img
            alt=''
            className='error-img mb-7'
            src={toAbsoluteUrl('/media/500.svg')}
          />
          <h1 className='fw-bolder fs-4x text-gray-700 mb-7 text-center'>Page Not Found</h1>
          <div className='fw-bold fs-3 text-gray-400 mb-10 text-center'>
            The page you looked not found!<br /> Plan your blog post by choosing a topic
          </div>
          <div className='text-center'>
            <Link to='/' className='btn btn-lg btn-primary fw-bolder'>
              Go to homepage
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}

export { Error500 }
